import { Languages, Moon, Sun } from 'lucide-react';

import { useUiPreferences } from '../i18n/ui-preferences.js';

export function PreferenceControls() {
  const { locale, t, theme, toggleLocale, toggleTheme } = useUiPreferences();
  return (
    <div
      className="preference-controls"
      role="group"
      aria-label={t('界面偏好', 'Interface preferences')}
    >
      <button
        className="preference-control"
        type="button"
        aria-label={
          theme === 'light'
            ? t('切换到暗色模式', 'Switch to dark mode')
            : t('切换到亮色模式', 'Switch to light mode')
        }
        onClick={toggleTheme}
      >
        {theme === 'light' ? <Moon aria-hidden="true" /> : <Sun aria-hidden="true" />}
      </button>
      <button
        className="preference-control language-control"
        type="button"
        aria-label={
          locale === 'zh-CN'
            ? t('切换到英文', 'Switch to English')
            : t('切换到中文', 'Switch to Chinese')
        }
        onClick={toggleLocale}
      >
        <Languages aria-hidden="true" />
        <span>{locale === 'zh-CN' ? 'EN' : '中文'}</span>
      </button>
    </div>
  );
}
